<template>
    <v-dialog
            content-class="editing-dialog"
            :value="value"
            width="600"
            transition="dialog-bottom-transition"
            @input="$emit('input')"
    >
        <v-toolbar
                flat
                dark
                class="main--yellow"
        >
            <v-btn
                depressed
                dark
                text
            >
                <clipper-upload v-model="imgURL">{{ $t('uploadImage') }}</clipper-upload>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn text @click.native="$emit('input')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card class="avatar-clipper-card">
            <v-layout row wrap justify-space-around align-stretch class="py-10">
                <v-flex xs10 md6 class="pb-8-small">
                    <clipper-basic
                            ref="avatarClipper"
                            :src="imgURL"
                            preview="avatar-preview"
                            :ratio="1"
                    >
                    </clipper-basic>
                </v-flex>
                <v-flex xs10 md3>
                    <clipper-preview name="avatar-preview" ></clipper-preview>
                </v-flex>
            </v-layout>
            <!--<div class="d-flex justify-center py-6" v-if="!imgURL">
                <v-btn
                        color="main&#45;&#45;yellow"
                        depressed
                        large
                        dark
                >
                    <clipper-upload v-model="imgURL">{{ $t('uploadImage') }}</clipper-upload>
                </v-btn>
            </div>-->
            <div class="d-flex justify-center py-6" v-if="imgURL">
                <v-btn
                        color="main--yellow"
                        depressed
                        large
                        dark
                        @click="saveImage"
                >
                    {{ $t('save') }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>

</template>

<script>
    import ProfileService from '../../../services/api/ProfileService';

    import "./style.scss";

    export default {
        name: "AvatarEdit",
        props: ['value', 'image'],
        data(){
            return {
                imgURL: '',
                resultURL: ''
            }
        },
        methods: {
            saveImage(){
                const canvas = this.$refs.avatarClipper.clip();
                this.resultURL = canvas.toDataURL("image/png", 1);

                ProfileService.saveAvatar({image: this.resultURL})
                    .then(res => {
                        this.$emit('image-uploaded', res.data.url);
                        this.$emit('input');
                    })
                    .catch(err => {
                        console.log(err.data);
                    });
            }
        }
    }
</script>

<style scoped>
    .editing-dialog {
        min-height: 500px;
    }
</style>
